import 'unfetch/polyfill';
import Fuse from 'fuse.js';
import {h, Component} from 'preact';
import ListAssociatedUsers from './list-associated-users.js';
import FilterAssociatedUsersInput from './filter-associated-users-input.js';
import IpRangeEnablerAssociatedUsers from './iprange-enabler-associated-users';
import AddAssociatedUsers from './add-associated-users';
import ErrorMessage from './error-message';

export default class WrapperListAssociatedUsers extends Component {
	constructor() {
		super();
		this.state = {
			users: [],
			isIpRangeAccessEnabled: false,
			isIpRangeAccessEnabledError: false,
			filteredUsers: [],
			usersError: undefined,
			searchQuery: '',
			visibilityControllerStatus: 'LIST'
		};
		this.handleFilterChange = this.handleFilterChange.bind(this);
		this.handleFilterClick = this.handleFilterClick.bind(this);
		this.handleFilterFormSubmission = this.handleFilterFormSubmission.bind(this);
		this.handleIpRangeEnablerChange = this.handleIpRangeEnablerChange.bind(this);
	}

	fetchAssociatedUsers() {
		const bpid = window.BPID;
		return fetch(`/organizations/${bpid}/associated-users`).then(response => {
			if (!response.ok) {
				// we will handle this later
				throw new Error(`Request rejected with status ${response.status}`);
			}
			return response.json();
		});
	}

	componentDidMount() {
		this.fetchAssociatedUsers().then(data => {
			this.setState({
				users: data.data.users,
				usersError: data.data.error,
				isIpRangeAccessEnabled: data.settingIpRangeAccess.isEnabled,
				isIpRangeAccessEnabledError: data.settingIpRangeAccess.error
			});
			if (data.data.users.length < 11) {
				this.setState({visibilityControllerStatus: 'LIST'});
			} else {
				this.setState({visibilityControllerStatus: 'FILTER'});
			}
		}).catch(error => console.log('WrapperListAssociatedUsers componentDidMount Error:', error));
	}

	handleFilterChange(event) {
		this.setState({searchQuery: event.target.value});
		if (event.target.value.length >= 3) {
			this.handleFilterClick(event);
		}
	}

	handleFilterFormSubmission(event) {
		event.preventDefault();
	}

	handleIpRangeEnablerChange(event) {
		event.preventDefault();
		const bpid = window.BPID;
		fetch(`/organizations/${bpid}/associated-users/ip-range-access`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json'
			},
			credentials: 'include',
			body: JSON.stringify({isIpRangeAccessEnabled: event.target.checked})
		}).then(response => {
			if (!response.ok) {
				// we will handle this later
				throw new Error(`Request rejected with status ${response.status}`);
			}
			return response.json();
		}).then(data => {
			this.setState({
				isIpRangeAccessEnabled: data.isEnabled
			});
		}).catch(error => console.log('Error:', error));
	}

	handleFilterClick(event) {
		const options = {
			shouldSort: true,
			threshold: 0.3,
			location: 0,
			distance: 100,
			maxPatternLength: 32,
			minMatchCharLength: 1,
			keys: [
				'firstName',
				'lastName',
				'email'
			]
		};
		const fuse = new Fuse(this.state.users, options);
		const filteredUsers = fuse.search(this.state.searchQuery);
		const filteredUsersNormalized = filteredUsers.map(u => ({refIndex: u.refIndex, ...u.item}));
		this.setState({filteredUsersNormalized, visibilityControllerStatus: 'RESULTS'});
	}

	render(properties, state) {
		if (state.usersError) {
			return <ErrorMessage text="At the moment we cannot display who are associated with your organization.
				We apologize. Reload the page in a few minutes to see if the problem has been solved." />;
		}
		switch (state.visibilityControllerStatus) {
			case 'LIST':
				return <div>
					<p>You currently have {state.users.length} associated users.</p>
					<ListAssociatedUsers users={state.users} visibilityControllerStatus={state.visibilityControllerStatus} />
					<AddAssociatedUsers />
					<IpRangeEnablerAssociatedUsers checked={state.isIpRangeAccessEnabled} handleIpRangeEnablerChange={this.handleIpRangeEnablerChange} error={state.isIpRangeAccessEnabledError} />
				</div>;
			case 'FILTER':
				return <div>
					<p>You currently have {state.users.length} associated users.</p>
					<FilterAssociatedUsersInput handleFilterChange={this.handleFilterChange} handleFilterClick={this.handleFilterClick} handleFilterFormSubmission={this.handleFilterFormSubmission} searchQuery={state.searchQuery} />
					<AddAssociatedUsers />
					<IpRangeEnablerAssociatedUsers checked={state.isIpRangeAccessEnabled} handleIpRangeEnablerChange={this.handleIpRangeEnablerChange} error={state.isIpRangeAccessEnabledError} />
				</div>;
			case 'RESULTS':
				return <div>
					<p>You currently have {state.users.length} associated users.</p>
					<FilterAssociatedUsersInput handleFilterChange={this.handleFilterChange} handleFilterClick={this.handleFilterClick} handleFilterFormSubmission={this.handleFilterFormSubmission} searchQuery={state.searchQuery} />
					<ListAssociatedUsers users={state.filteredUsersNormalized} visibilityControllerStatus={state.visibilityControllerStatus} />
					<AddAssociatedUsers />
					<IpRangeEnablerAssociatedUsers checked={state.isIpRangeAccessEnabled} handleIpRangeEnablerChange={this.handleIpRangeEnablerChange} error={state.isIpRangeAccessEnabledError} />
				</div>;
		}
	}
}
